// This file was automatically generated from appchart.refpanel.legal.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.legal');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.reports');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.legal.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="legal-reports-summary" class="fieldLabelContainerNoBorder">');
  if (opt_data.items.length) {
    output.append('<ol class="ebs-list-unstyled">');
    var itemList5341 = opt_data.items;
    var itemListLen5341 = itemList5341.length;
    for (var itemIndex5341 = 0; itemIndex5341 < itemListLen5341; itemIndex5341++) {
      var itemData5341 = itemList5341[itemIndex5341];
      output.append('<li class="am-highlight el8BulletText el8ItemHover" id="ref_legal_', soy.$$escapeHtml(itemData5341.id), '"><div class="el8ItemButtonContainer"><button tabindex="-1" type="button" data-id="', soy.$$escapeHtml(itemData5341.id), '" class="el8button more-actions-trigger el8ActionButton ebs-btn ebs-btn-default">Action<span class="el8ButtonDropdownIcon"></span></button></div><a class="details-trigger" data-id="', soy.$$escapeHtml(itemData5341.id), '">');
      el8.template.ptdata.reports.refPanelLegalReport(itemData5341, output);
      output.append('</a></li>');
    }
    output.append('</ol>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};
